var map = {
	"./appImage-customer-base--1.svg": "8bf7",
	"./appImage-customer-base--2.svg": "c308",
	"./appImage-customer-base--3.svg": "612c",
	"./appImage-customer-base--preview.svg": "afb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6258";